import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { PageHeaderComponent } from '../../page/header/page-header.component';
@Directive({
    selector: '[pageHeaderMeganavContentArea]',
    standalone: true
})
export class PageHeaderMaganavContentAreaDirective implements OnInit, OnDestroy {
    /**
     * Toggle id entry to catch events
     */
    @Input()
    toggleClassBy?: NToggle.TId;
    private subscription!: Subscription;
    constructor(
        private elementRef: ElementRef,
        private toggleService: ToggleService,
        private pageHeaderComponent: PageHeaderComponent
    ) {}
    /**
     * Initialize
     */
    ngOnInit(): void {
        // scroll wrapper back to top when we opening
        if (this.toggleClassBy) {
            this.subscription = this.toggleService.getItem(this.toggleClassBy).state.subscribe(visible => {
                if (visible) {
                    this.elementRef.nativeElement.scrollTop = 0;
                }
                this.pageHeaderComponent.toggleCmsNode(this.elementRef.nativeElement, visible);
            });
        }
    }
    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.pageHeaderComponent.toggleCmsNode(this.elementRef.nativeElement, false);
    }
}
